module.exports = __webpack_public_path__ + "assets/img/triangle1.85f450d8.svg";